import React, { InputHTMLAttributes } from "react";
import { TextField, TextArea } from "@duik/it";
import cls from "./input.module.scss";
import { connect, useSelector } from "react-redux";
import { AppState } from "@redux";
import classNames from "classnames";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  handleChange: (e: InputHTMLAttributes<HTMLInputElement>) => void;
  value: string;
  name: string;
  secure?: boolean;
  icon?: React.ReactNode;
  errorMessage?: string;
  placeholder?: string;
  longtooltip?: boolean;
  tooltip?: boolean;

}
export const Input = ({
  label,
  handleChange,
  name,
  value,
  secure = false,
  icon = <div></div>,
  errorMessage = "",
  type,
  placeholder,
  tooltip = false,
  longtooltip = false,
}: InputProps) => {
  const errors = useSelector(
    (state: AppState) => state.form && state.form.errors
  );
  const getReduxErrorMessage = () => {
    if (errors && errors[name]) {
      return errors[name];
    }

    return null;
  };
  const errMsg = errorMessage || getReduxErrorMessage();
  return type === "date" ? (
    <div className={cls.Wrapper}>
      <div className={cls.textFieldWrapper}>
        <div className={cls.text}>{label}</div>
        <TextField
          className={cls.textFiled}
          clear
          onChange={handleChange}
          name={name}
          value={value}
          type={type}
          style={{ marginRight: 10 }}
        />
      </div>
      {errMsg && <p className={cls.errorMessage}>{errMsg}</p>}
    </div>
  ) : type === "textarea" ? (
    <div className={cls.Wrapper}>
      <div className={cls.textAreaWrapper}>
        <div className={cls.text}>{label}</div>
        <TextArea
          className={cls.textFiled}
          clear
          onChange={handleChange}
          name={name}
          value={value}
          rightEl={<div className={cls.icon}>{icon}</div>}
          placeholder={placeholder || "Text area"}
        />
      </div>
      {errMsg && <p className={cls.errorMessage}>{errMsg}</p>}
    </div>
  ) : (
    <div className={cls.Wrapper}>
      <div className={cls.textFieldWrapper}>
        <div className={tooltip ? classNames(cls.text, cls.tooltip) : cls.text}>
          {label}

          {tooltip && (
            <span
              className={
                longtooltip
                  ? classNames(cls.tooltiptext, cls.longtooltip)
                  : cls.tooltiptext
              }
            >
              {label}
            </span>
          )}
        </div>
        <TextField
          className={cls.textFiled}
          clear
          onChange={handleChange}
          name={name}
          value={value}
          rightEl={<div className={cls.icon}>{icon}</div>}
          type={type}
        />
      </div>
      {errMsg && <p className={cls.errorMessage}>{errMsg}</p>}
    </div>
  );
};

export default Input;
